import React from "react";
import { Box, Grid, Typography } from "@mui/material";
import { Images } from "../../../../helpers/Images";

const highlights = [
  { label: "STEAM Learning", accent: "#23aef4" },
  { label: "Teamwork", accent: "#c11a83" },
  { label: "Innovation", accent: "#23aef4" },
];

const Theme = () => {
  return (
    <Box
      component="section"
      sx={{
        width: "100%",
        position: "relative",
        overflow: "hidden",
        background:
          "linear-gradient(180deg, #fafbfc 0%, #ffffff 45%, #f7f9fc 100%)",
      }}
    >
      <Box
        sx={{
          position: "absolute",
          inset: 0,
          pointerEvents: "none",
          background:
            "radial-gradient(700px 400px at 8% 20%, rgba(35, 174, 244, 0.10), transparent 60%), radial-gradient(600px 380px at 92% 70%, rgba(193, 26, 131, 0.08), transparent 55%)",
        }}
      />

      <Box
        sx={{
          position: "relative",
          width: "100%",
          maxWidth: "1500px",
          margin: "0 auto",
          padding: {
            xs: "48px 20px",
            sm: "64px 60px",
            lg: "80px 120px",
          },
        }}
      >
        <Grid
          container
          spacing={{ xs: 4, md: 6 }}
          alignItems="center"
          justifyContent="space-between"
        >
          <Grid item xs={12} md={7}>
            <Box
              sx={{
                // display: "inline-flex",
                width: "fit-content",
                alignItems: "center",
                px: 1.75,
                py: 0.75,
                mb: 2,
                borderRadius: "999px",
                backgroundColor: "rgba(35, 174, 244, 0.10)",
                border: "1px solid rgba(35, 174, 244, 0.22)",
                margin: { xs: "0 auto 16px", md: "0 0 16px" }
              }}
            >
              <Typography
                sx={{
                  fontSize: { xs: "12px", md: "13px" },
                  fontWeight: 700,
                  letterSpacing: "0.08em",
                  textTransform: "uppercase",
                  color: "#23aef4",
                }}
              >
                We Do Challenge Chmapionship
              </Typography>
            </Box>

            <Typography
              component="h2"
              sx={{
                color: "primary.darker",
                fontSize: { xs: "28px", sm: "34px", md: "42px" },
                lineHeight: 1.15,
                fontWeight: 800,
                letterSpacing: "-0.02em",
                textAlign: { xs: "center", md: "start" },
              }}
            >
              Inspiring Young Minds Through{" "}
              <Box
                component="span"
                sx={{
                  background:
                    "linear-gradient(90deg, #23aef4 0%, #c11a83 100%)",
                  WebkitBackgroundClip: "text",
                  WebkitTextFillColor: "transparent",
                  backgroundClip: "text",
                }}
              >
                Robotics & Innovation
              </Box>
            </Typography>

            <Box
              sx={{
                height: "4px",
                width: { xs: "80px", md: "120px" },
                borderRadius: "999px",
                background:
                  "linear-gradient(90deg, #23aef4 0%, #c11a83 100%)",
                margin: { xs: "14px auto 22px", md: "16px 0 24px" },
              }}
            />

            <Typography
              sx={{
                color: "primary.darker",
                lineHeight: 1.5,
                fontSize: { xs: "16px", md: "16px" },
                maxWidth: "600px",
                textAlign: { xs: "center", md: "start" },
                margin: { xs: "0 auto", md: "0" },
              }}
            >
              The{" "}
              <Box component="span" sx={{ color: "#23aef4", fontWeight: 700 }}>
                We Do Challenge
              </Box>{" "}
              is an exciting robotics competition designed for young students to
              explore STEAM (Science, Technology, Engineering, Arts, and
              Mathematics) through hands-on learning and teamwork. This challenge
              encourages creativity, problem-solving, and innovation.
            </Typography>

            <Box
              sx={{
                display: "flex",
                flexWrap: "wrap",
                gap: 1.25,
                mt: 3,
                justifyContent: { xs: "center", md: "flex-start" },
              }}
            >
              {highlights.map((item) => (
                <Box
                  key={item.label}
                  sx={{
                    px: 1.75,
                    py: 1,
                    borderRadius: "14px",
                    backgroundColor: "#fff",
                    border: "1px solid rgba(89, 92, 97, 0.12)",
                    boxShadow: "0 8px 24px rgba(10, 14, 24, 0.06)",
                  }}
                >
                  <Typography
                    sx={{
                      fontSize: { xs: "13px", md: "14px" },
                      fontWeight: 700,
                      color: "primary.darker",
                    }}
                  >
                    <Box
                      component="span"
                      sx={{
                        display: "inline-block",
                        width: "8px",
                        height: "8px",
                        borderRadius: "50%",
                        backgroundColor: item.accent,
                        mr: 1,
                        verticalAlign: "middle",
                      }}
                    />
                    {item.label}
                  </Typography>
                </Box>
              ))}
            </Box>
          </Grid>

          <Grid item xs={12} md={5}>
            <Box
              sx={{
                position: "relative",
                width: "100%",
                maxWidth: { xs: "100%", md: "520px" },
                margin: { xs: "0 auto", md: "0 0 0 auto" },
              }}
            >
              <Box
                sx={{
                  position: "absolute",
                  inset: { xs: "-10px", md: "-14px" },
                  borderRadius: "24px",
                  background:
                    "linear-gradient(135deg, rgba(35, 174, 244, 0.35), rgba(193, 26, 131, 0.25))",
                  filter: "blur(2px)",
                  zIndex: 0,
                }}
              />
              <Box
                component="img"
                src={Images.post}
                alt="Students building robots at We Do Challenge"
                sx={{
                  position: "relative",
                  zIndex: 1,
                  width: "100%",
                  minHeight: { xs: "220px", md: "300px" },
                  objectFit: "cover",
                  borderRadius: "20px",
                  border: "1px solid rgba(255, 255, 255, 0.8)",
                  boxShadow: "0 24px 60px rgba(10, 14, 24, 0.18)",
                  display: "block",
                }}
              />
            </Box>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};

export default Theme;
